import 'moment/locale/en-gb';

import enMessages from 'locales/messages.end-GB.json';

export const MESSAGES = {
  en: enMessages,
};
